import React from "react";
import Box from "../../lib/appfuse-react/component/Box";
import Typography from "@material-ui/core/Typography";
import i18n from "../../lib/appfuse-react/core/i18n";
import RegionButton from "./RegionButton";
import Button from "../../lib/appfuse-react/component/Button";
import useRouter from "../../lib/appfuse-react/hook/useRouter";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";

const STEPS = ['Please choose your certification region', 'Start register'];

/**
 * 註冊-選擇驗證地區
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

function RegistrationMain(props){
    const { step, region } = props;
    const router = useRouter();
    const handleSignInInstead = () => router.login();
    const title = STEPS[step];

    return (
        <Box paddingTop="10%" fullWidth fullHeight overflow="hidden" display="flex" flexDirection="column">
            <Box display="flex" flexDirection="column" fullWidth overflow="auto" height="90%">
                <Box display="flex" justifyContent="center" paddingTop={1} paddingBottom={5}>
                    <Typography variant="h3" color="textPrimary">{i18n.translate(title)}</Typography>
                </Box>
                <Box fullWidth paddingY={1}>
                    <RegionButton onClick={props.handleRegion} region={region}/>
                </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" paddingTop={3}>
                <Button text="Sign in instead" color="secondary" onClick={handleSignInInstead} />
                { step === 1 && <Button text="Next" variant="contained" color="primary" onClick={props.onNext}/>}
            </Box>
        </Box>
    )
}

export function StartStepper(props){
    const { registerStep } = props;

    return (
        <Stepper activeStep={registerStep} orientation="vertical">
            {STEPS.map((label, index) =>  (
                <Step key={label}>
                    <StepLabel><Typography>{i18n.translate(label)}</Typography></StepLabel>
                </Step>
            ))}
        </Stepper>
    )
}

export default RegistrationMain;